import {
    SET_LOCALE,
} from "../mutations";

import {
    SET_LOCALE_A,
} from "../actions";


const mutations = {
    [SET_LOCALE]: (state, newlocale) =>{
      state.lang = newlocale.lang;
      if (state.lang === "en"){
        state.Language = "English";
      }
      else if(state.lang === "pl"){
        state.Language = "Polski";
      }
    }
}

const state = {
    lang: "en",
    Language: "English",
  }

const getters = {
    get_locale(state) {
      return state.lang;
    },
    get_language(state) {
        return state.Language;
    },
}

const actions = {
    [SET_LOCALE_A](context, newlocale) {
        context.commit(SET_LOCALE, newlocale)
    }
}

export default {
    state,
    mutations,
    actions,
    getters
  }


// WEBPACK FOOTER //
// ./src/store/modules/locale.js